import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { portfolioArchive, type PortfolioProject } from '../data/portfolio';
import { contractedCompanies } from '../data/contractedCompanies';
import './StudioWorkList.css';

type WorkFilter = '전체' | '웹' | '앱' | '콘텐츠';

const filters: WorkFilter[] = ['전체', '웹', '앱', '콘텐츠'];
const categoryOf = (project: PortfolioProject): Exclude<WorkFilter, '전체'> => {
  if (project.categories.includes('콘텐츠 디자인')) return '콘텐츠';
  if (project.categories.includes('앱')) return '앱';
  return '웹';
};

const StudioWork: React.FC = () => {
  const [filter, setFilter] = useState<WorkFilter>('전체');
  const visibleProjects = portfolioArchive.filter((project) => filter === '전체' || categoryOf(project) === filter);

  return (
    <section className="studio-work-list" id="work" aria-labelledby="studio-work-title">
      <div className="studio-shell">
        <div className="studio-work-list-top"><span>PROJECT ARCHIVE</span><span>001 — {String(portfolioArchive.length).padStart(3, '0')}</span></div>
        <div className="studio-work-list-heading">
          <div><p>WORK / PORTFOLIO</p><h2 id="studio-work-title">작업 아카이브<span>.</span></h2></div>
          <p className="studio-work-list-summary">완료한 프로젝트를 한 줄씩 기록합니다. 프로젝트 내역과 함께한 회사는 확인되는 순서대로 계속 추가됩니다.</p>
        </div>
        <div className="studio-work-list-toolbar">
          <div className="studio-work-list-filters" aria-label="작업 분야 필터">
            {filters.map((item) => <button key={item} type="button" aria-pressed={filter === item} className={filter === item ? 'active' : ''} onClick={() => setFilter(item)}>{item}<span>{item === '전체' ? portfolioArchive.length : portfolioArchive.filter((project) => categoryOf(project) === item).length}</span></button>)}
          </div>
          <span className="studio-work-list-count">{visibleProjects.length} PROJECTS</span>
        </div>
        <div className="studio-work-list-table" aria-label={`${filter} 작업 목록`}>
          {visibleProjects.map((project, index) => (
            <Link className="studio-work-list-row" key={project.slug} to={`/portfolio/${project.slug}`} aria-label={`${project.title} 프로젝트 상세 보기`}>
              <span className="studio-work-list-number">{String(index + 1).padStart(2, '0')}</span>
              <strong>{project.title}</strong>
              <span className="studio-work-list-category">{categoryOf(project)}</span>
            </Link>
          ))}
        </div>
        <div className="studio-work-list-clients" aria-labelledby="studio-clients-title">
          <div className="studio-work-list-clients-heading">
            <span>CLIENTS / PARTNERS</span>
            <h3 id="studio-clients-title">함께한 회사<span>.</span></h3>
            <p>계약 회사는 공개 가능한 곳부터 하나씩 추가합니다.</p>
          </div>
          <div className="studio-work-list-company-list">
            {contractedCompanies.length > 0 ? contractedCompanies.map((company, index) => (
              <div className="studio-work-list-company" key={company.name}>
                <span>{String(index + 1).padStart(2, '0')}</span>
                {company.website ? <a href={company.website} target="_blank" rel="noopener noreferrer">{company.name} <span aria-hidden="true">↗</span></a> : <strong>{company.name}</strong>}
              </div>
            )) : <p className="studio-work-list-company-empty">공개가 확인된 회사명을 준비 중입니다.</p>}
          </div>
        </div>
      </div>
    </section>
  );
};

export default StudioWork;
